import { useTranslation } from 'react-i18next'
import CalendarIcon from '@mui/icons-material/CalendarMonthOutlined'

import {
  useGetQuoteDeliveryWindow,
  useGetQuoteJobDate,
  type Quote,
} from '../../../modules/quotes'
import { useDateFormatter } from '../../../utils/date'

type DateRangesProps = {
  quote: Quote
  jobIndex: number
}

const DateRanges: React.FC<DateRangesProps> = ({
  quote,
  jobIndex,
}) => {
  const { t } = useTranslation()
  const formatDate = useDateFormatter()
  const getQuoteJobDate = useGetQuoteJobDate()
  const getQuoteDeliveryWindow = useGetQuoteDeliveryWindow()

  const job = quote.jobs[jobIndex]
  if (!job) {
    return null
  }

  const pickup = getQuoteJobDate(job)
  const delivery = getQuoteDeliveryWindow(job)

  if (!pickup?.to && !delivery) {
    return null
  }

  return (
    <div className="-mx-4 mt-2 rounded-lg bg-gray-100 p-4 text-base leading-tight text-gray-500 md:-mx-2 md:mb-8 md:mt-1">
      { pickup && (
        <>
          <h2 className="mb-2 font-body2 text-sm font-bold text-neutral-700">
            <div className="flex items-center gap-1">
              <CalendarIcon className="!text-[20px] text-neutral-600" />
              { t('quotes.quote.pickupWindow') }
            </div>
          </h2>
          { formatDate(pickup) }
        </>
      ) }

      { pickup && delivery && <hr className="my-4 border-neutral-300" /> }

      { delivery && (
        <>
          <h2 className="mb-2 font-body2 text-sm font-bold text-neutral-700">
            <div className="flex items-center gap-1">
              <CalendarIcon className="!text-[20px] text-neutral-600" />
              { t('quotes.quote.deliveryWindow') }
            </div>
          </h2>
          { formatDate(delivery) }
        </>
      ) }
    </div>
  )
}

export default DateRanges
